import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import axios from "axios";

import Filters from "../General/Filters.js";
//import { getDefaultFilterSelect } from "../services/FilterDataService";
import {
  filterOptionsAction,
  setFilterOptionsAction,
  filterOptionsSelectedAction,
  filterDataAction,
  defaultFilterDataAction
} from "../../redux/actions/index";
import PioneerToolLogo from "./lithia.png";

import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import Login from "@mui/icons-material/Login";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";

import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import Info from "@mui/icons-material/MenuBook";

const drawerWidth = 400;
const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});
const lightTheme = createTheme({
  palette: {
    mode: "light",
  },
});
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri`,
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    background: "#fff",
  },
  title: {
    flexGrow: 1,
    fontFamily: "Circular Pro",
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBarDark: {
    background: "#E5E7E9",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShiftDark: {
    background: "#E5E7E9",
    marginLeft: drawerWidth,
    //width: `calc(100% - ${drawerWidth}px)`,
    width: "100%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarLight: {
    background: "#E5E7E9",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShiftLight: {
    background: "#E5E7E9",
    marginLeft: drawerWidth,
    //width: `calc(100% - ${drawerWidth}px)`,
    width: "100%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  drawerPaperDark: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    background: "#1F2121",
    overflowX: "hidden",
  },
  drawerPaperCloseDark: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    /*width : theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(3),
    } */
    width: 50,
    background: "#1F2121",
    overflowX: "hidden",
  },
  drawerPaperLight: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    background: "#E5E7E9",
    overflowX: "hidden",
  },
  drawerPaperCloseLight: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    /*width : theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(3),
    } */
    width: 50,
    background: "#E5E7E9",
    overflowX: "hidden",
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 40,
  },
  selectDrawerIcon: {
    borderLeft: "4px",
    borderColor: "#FFFFFF",
    borderLeftStyle: "solid",
    background: "rgba(0,0,0,0.3) !important",
    height: "50px",
  },
  drawerIcon: {
    marginLeft: "4px",
    height: "50px",
  },
  listItemText: {
    display: "flex",
    color: "#FFFFFF",
    fontWeight: 400,
    fontSize: "16px",
    paddingLeft: "0.25rem",
  },
  title: {
    display: "flex",
    color: "#000",
    fontSize: "18px",
    alignItems: "center",
    paddingLeft: "0.25rem",
    fontFamily: "Circular Pro,CircularXXWeb,serif",
    fontWeight: "bold",
  },
  user: {
    fontSize: "12px",
    color: "#000",
    display: "flex",
    alignItems: "center",
    paddingRight: "0.50rem",
  },
  drawerToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 8px",
    height: theme.spacing(7),
  },
}));

const StyledBadgeLogin = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#1451B5",
    color: "#1451B5",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const StyledBadgeLogOff = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#CACFD2",
    color: "#CACFD2",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

// const StyledBadgeLogOff1 = styled(Badge)(({ theme }) => ({
//   "& .MuiBadge-badge": {
//     backgroundColor: "#B3B5B8",
//     color: "#B3B5B8",
//     boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
//     "&::after": {
//       position: "absolute",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       borderRadius: "50%",
//       content: '""',
//     },
//   },
//   "@keyframes ripple": {
//     "0%": {
//       transform: "scale(.8)",
//       opacity: 1,
//     },
//     "100%": {
//       transform: "scale(2.4)",
//       opacity: 0,
//     },
//   },
// }));

const hostUrl = process.env.REACT_APP_HOST ? process.env.REACT_APP_HOST : "";

export function Navigation(props) {
  const classes = useStyles();
  const history = props.history;
  const [lightMode, setLightMode] = useState(false);
  const [open, setOpen] = useState(false);
  const [filterOptions, setFilterOptions] = useState(
    props.metaData.filterOptions
  );
  
  const [defaultFilterValues, setDefaultFilterValues] = useState(
    props.defaultFilterData.defaultFilterValues
  );

  //Logoff menu
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // const publicClientApplication = new PublicClientApplication({
  //   auth:{
  //     clientId : config.appId,
  //     redirectUri: config.redirectUri,
  //     authority : config.authority
  //   },
  //   cache: {
  //     cacheLocation: "sessionStorage",
  //     storeAuthStateInCookie: true
  //   }
  // });
  const handleLogin = () => {
    //reset all props    
    const userObj = {
      name: "",
      email: "",
      login: true,
      logout: false,
    };
    props.setFilterOptionsAction(userObj);
    history.push("/login");
  };

  const handleLogOff = () => {
    //reset all props       
    const userObj = {
      name: "",
      email: "",
      login: false,
      logout: true,
    };
    const filterObj = {
      filterData: [],
      isLoading: false,
    };
    props.setFilterOptionsAction(userObj);
    props.filterDataAction(filterObj);
    //props.filterOptionsSelectedAction(getDefaultFilterSelect);
    props.filterOptionsSelectedAction(null);
    setOpen(false); //drawer close
    history.push("/logout");
  };

  //const history = createBrowserHistory();
  const handleDrawer = () => {
    setOpen(!open);
  };

  const handleThemeMode = () => {
    setLightMode(!lightMode);
  };

  //componentDidMount
  useEffect(() => {
    checkForUserDetails();
    if (
      filterOptions.regions.length === 0 ||
      filterOptions.states.length === 0 ||
      filterOptions.rawMakes.length === 0 ||
      filterOptions.rawModels.length === 0 ||
      filterOptions.rawStyles.length === 0 ||
      filterOptions.condition.length === 0 ||
      filterOptions.fico.length === 0 ||
      filterOptions.income.length === 0 ||
      filterOptions.rawData.length === 0
    ) {
      console.log("Filter Data", filterOptions, process.env.REACT_APP_HOST);
      fetchFilterOptionsFromDb();
    }    
    
    if(defaultFilterValues === null || defaultFilterValues === undefined){    
        fetchDefaultFilterValueFromDb();
    }
  }, [filterOptions, defaultFilterValues]);

  // const fetchFilterOptionsFromCache = () => {
  //   const postObj = {
  //     key: "pioneer_tool_filter_options",
  //   };
  //   console.log(
  //     "host url and postobj",
  //     `${hostUrl}/api/getCachedData`,
  //     postObj
  //   );
  //   axios
  //     .post(`${hostUrl}/api/getCachedData`, postObj)
  //     .then((result) => {
  //       let options = {};
  //       console.log("Filter Options from Cache", result.data);
  //       options = result.data.value;
  //       console.log("Options", options);
  //       if (options) {
  //         props.filterOptionsAction({ filterOptions: options });
  //         setFilterOptions(options);
  //       } else {
  //         fetchFilterOptionsFromDb();
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("Error", err.message);
  //       return {};
  //     });
  // };

  const fetchFilterOptionsFromDb = () => {
    const payload = {
      client: true,
    };

    axios
      .post(`${hostUrl}/api/getFilterMetaData`, payload)
      .then((result) => {
        console.log("Filter Options from DB", result.data);
        //props.setFilterOptionsAction({ filterOptions: result.data });
        props.filterOptionsAction({ filterOptions: result.data });
        setFilterOptions(result.data);
        //setFilterOptionsInCache(result.data);
      })
      .catch((err) => {
        console.log("Error", err.message);
      });
  };

  const fetchDefaultFilterValueFromDb = () => {
    const payload = {
      client: true,
    };

    axios
      .post(`${hostUrl}/api/getDefaultFiltersData`, payload)
      .then((result) => {
        console.log("Default Filter Values from DB", result.data);        
        props.defaultFilterDataAction({ defaultFiltersValues: result.data });
        setDefaultFilterValues(result.data);        
      })
      .catch((err) => {
        console.log("Error", err.message);
      });
  };

  // const setFilterOptionsInCache = (filterOptions) => {
  //   const postObj = {
  //     key: "pioneer_tool_filter_options",
  //     value: filterOptions,
  //   };
  //   console.log("filterOptions", postObj);
  //   axios
  //     .post(`${hostUrl}/api/setCache`, postObj)
  //     .then((result) => {
  //       //setFilterOptions(filterOptions);
  //       console.log("filter Options set to cache", result.data);
  //     })
  //     .catch((err) => {
  //       //setFilterOptions(filterOptions);
  //       console.log("Error", err.message);
  //     });
  // };

  const navigateToHome = () => {
    //return null;
    console.log("history", history);
    //props.children[0]._self.props.history.push("/");
    if (props.user.name.trim() === "" || props.user.email.trim() === "") {
      history.push("/login");
    } else {
      history.push("/");
    }
  };

  const checkForUserDetails = () => {
    if (
      props.user.name.trim() === "" ||
      props.user.email.trim() === "" ||
      props.user.expiry
    ) {      
      history.push("/login");
    }
  };

  const navigateToHistory = () => {
    history.push("/historyView");
  };

  const navigateToUserGuide = () => {
    history.push("/userGuide");
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        //className={clsx(classes.appBar, open && classes.appBarShift)}
        className={
          !lightMode
            ? clsx(classes.appBarDark, open && classes.appBarShiftDark)
            : clsx(classes.appBarLight, open && classes.appBarShiftLight)
        }
      >
        <Toolbar className={classes.toolbar}>
          <div
            style={{
              display: "flex",              
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "left",
              width: "100%",
              height: "65px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "34%",
                height: "65px",
                alignItems: "center",
              }}
            >
              {/* <Link href="/" underline="none"> */}
              <IconButton
                color="primary"
                aria-label="Home"
                onClick={navigateToHome}
              >
                <img
                  style={{
                    width: "30px",
                    height: "30px",
                  }}
                  src={PioneerToolLogo}
                />
                <div className={classes.title}>
                  Driveway Vehicle Selection Tool
                </div>
              </IconButton>
              {/* </Link> */}
            </div>

            <div
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexGrow:"1",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                paddingLeft: "1rem",
                height: "65px",
                width: "20%",
              }}
            >
              {props.user && props.user.name.trim().length > 0 && (
                <>
                  {/* style={{ borderRight: "1px solid #99A3A4" }} */}
                  <div>
                    <IconButton
                      color="primary"
                      aria-label="UserGuide"
                      onClick={navigateToUserGuide}
                    >
                      <Info
                        //color="primary"
                        fontSize="large"
                        titleAccess="User Guide"
                        style={{ color: "#1451B5" }}
                      />
                    </IconButton>
                  </div>
                  {/* style={{ borderRight: "1px solid #99A3A4" }} */}
                  <div>
                    <IconButton
                      color="primary"
                      aria-label="History"
                      onClick={navigateToHistory}
                    >
                      <HistoryIcon
                        //color="primary"
                        fontSize="large"
                        titleAccess="History"
                        style={{ color: "#1451B5" }}
                      />
                    </IconButton>
                  </div>
                </>
              )}
              {props.user && props.user.name.trim().length > 0 ? (
                !lightMode ? (
                  <IconButton
                    color="primary"
                    aria-label="Theme"
                    onClick={handleThemeMode}
                  >
                    <LightModeIcon
                      //color="primary"
                      fontSize="medium"
                      titleAccess="Light Mode Theme"
                      style={{ color: "#1451B5" }}
                    />
                  </IconButton>
                ) : (
                  <IconButton
                    color="primary"
                    aria-label="Theme"
                    onClick={handleThemeMode}
                  >
                    <DarkModeIcon
                      //color="primary"
                      fontSize="medium"
                      titleAccess="Dark Mode Theme"
                      style={{ color: "#1451B5" }}
                    />
                  </IconButton>
                )
              ) : (
                <></>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderLeft: "1px solid #99A3A4",
                  paddingLeft: "1rem",
                  alignItems: "center",
                }}
              >
                <div className={classes.user}>
                  <Typography
                    variant="string"
                    style={{ textTransform: "capitalize" }}
                  >
                    {props.user && props.user.name}
                  </Typography>
                </div>

                <Tooltip title="Login/Logout">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={openMenu ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openMenu ? "true" : undefined}
                  >
                    {props.user && props.user.name.trim().length > 0 ? (
                      <StyledBadgeLogin
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        variant="dot"
                      >
                        <Avatar>
                          <FontAwesomeIcon
                            size="xs"
                            icon={faUser}
                            style={{ color: "#000" }}
                          />
                        </Avatar>
                      </StyledBadgeLogin>
                    ) : (
                      <StyledBadgeLogOff
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        variant="dot"
                      >
                        <Avatar>
                          <FontAwesomeIcon
                            size="xs"
                            icon={faUser}
                            style={{ color: "#000" }}
                          />
                        </Avatar>
                      </StyledBadgeLogOff>
                    )}
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>

      <ThemeProvider theme={lightMode ? lightTheme : darkTheme}>
        <Drawer
          variant="permanent"
          classes={
            !lightMode
              ? {
                  paper: clsx(
                    classes.drawerPaperDark,
                    !open && classes.drawerPaperCloseDark
                  ),
                }
              : {
                  paper: clsx(
                    classes.drawerPaperLight,
                    !open && classes.drawerPaperCloseLight
                  ),
                }
          }
          open={open}
        >
          {/* 
        onMouseOver = {handleDrawer}
        onMouseOut = {handleDrawer} */}
          <div className={classes.drawerToolbar}></div>
          {/* Filter Components */}
          <Filters
            handleDrawer={handleDrawer}
            history={history}
            isDrawerOpen={open}
            filterOptions={filterOptions}
            lightMode={lightMode}
            handleThemeMode={handleThemeMode}
            defaultValues={defaultFilterValues}
          />
          <Divider />
        </Drawer>
      </ThemeProvider>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openMenu}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {props.user && props.user.name.trim().length > 0 && (
          <MenuItem onClick={handleLogOff}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        )}
        {props.user && props.user.name.trim().length === 0 && (
          <MenuItem onClick={handleLogin}>
            <ListItemIcon>
              <Login fontSize="small" />
            </ListItemIcon>
            Login
          </MenuItem>
        )}
      </Menu>

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {props.children}
      </main>
    </div>
  );
}

const mstp = (state) => {
  return {
    user: state.user,
    metaData: state.metaData,
    selectedMetaData: state.selectedMetaData,
    filterData: state.filterData,
    defaultFilterData: state.defaultFilterData
  };
};

export default connect(mstp, {
  filterOptionsAction,
  setFilterOptionsAction,
  filterDataAction,
  filterOptionsSelectedAction,
  defaultFilterDataAction
})(Navigation);
